import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

const HeaderCell = (props) => {
    const {column, onClick} = props;
    return (
        <th
            onClick={onClick}
            width={column.width}
            className={classnames({
                "align-center": column.align === "center",
            })}
        >
            {column.label}
        </th>
    );
};

HeaderCell.propTypes = {
    column: PropTypes.shape({
        label: PropTypes.any,
        width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        align: PropTypes.string,
    }),
    onClick: PropTypes.func,
};

export default HeaderCell;



// WEBPACK FOOTER //
// ./app/lib/common/descriptorcontrols/BaseControls/RecordGrid/HeaderCell.js